import { defineMessages } from "react-intl";

import { node as cmv } from "src/modules/ktx/forms/basic-registration-data/viral-serology/cmv";
import { node as ebv } from "src/modules/ktx/forms/basic-registration-data/viral-serology/ebv";
import { node as hbvStatus } from "src/modules/ktx/forms/basic-registration-data/viral-serology/hbvStatus";
import { node as hcv } from "src/modules/ktx/forms/basic-registration-data/viral-serology/hcv";
import { node as hiv } from "src/modules/ktx/forms/basic-registration-data/viral-serology/hiv";
import { node as toxoplasma } from "src/modules/ktx/forms/basic-registration-data/viral-serology/toxoplasma";
import { node as treponemaPallidum } from "src/modules/ktx/forms/basic-registration-data/viral-serology/treponemaPallidum";
import { node as varicella } from "src/modules/ktx/forms/basic-registration-data/viral-serology/varicella";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "ktx.viral_serology",
		defaultMessage: "Vírusszerológia"
	}
});

export const node: ParentNode = {
	id: "ktx-viral-serology",
	value: { type: "list", title: messages.title },
	children: [
		cmv,
		ebv,
		hbvStatus,
		hcv,
		hiv,
		toxoplasma,
		treponemaPallidum,
		varicella
	]
};
